module.exports = __webpack_public_path__ + "media/recipes/104-a628254e.png";